export enum AddonsMetaID {
  COPILOT = '79b4ed00-fdf8-4c78-a46b-fb611f74f4b9',
  GRAPH_STUDIO = '8388d339-c481-4683-97da-5fef95b561b2',
  INSIGHTS = '3d29678e-4ee5-434e-8a63-2c4c480fe65b',
  GRAPHQL = '7a291356-b4d2-4f69-84aa-e98536f83505',

  // addon not list in backend
  ADMIN_PORTAL = 'ADMIN_PORTAL',
}
